module.exports = __webpack_public_path__ + "static/media/Golden Retriever - Pastel.a2d61ed2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Golden Retriever - Pastel.jpg
 ** module id = 397
 ** module chunks = 0
 **/